module.exports = __webpack_public_path__ + "static/media/docs-example.af911585.png";